import { shallowRef, watch, defineAsyncComponent } from 'vue'
import { useCustomerManager } from './CustomerManager'

const allCustomerComponents = import.meta.glob('../../customers/*/components/**/*.vue', { eager: true })
const allCustomerViews = import.meta.glob('../../customers/*/views/**/*.vue', { eager: true })

function getCustomerComponent (customer, componentName, environmentLevel) {
  const defaultComponentPath = `../../customers/defaults/components/${componentName}.vue`
  const customerComponentPath = `../../customers/${customer}/components/${componentName}.vue`
  const customerEnvironmentComponentPath = `../../customers/${customer}/components/environment/${environmentLevel}/${componentName}.vue`
  const componentModule = allCustomerComponents[customerEnvironmentComponentPath]
    ?? allCustomerComponents[customerComponentPath]
    ?? allCustomerComponents[defaultComponentPath]
  return componentModule ? componentModule.default : null
}

function getCustomerView (customer, viewName) {
  const defaultViewPath = `../../customers/defaults/views/${viewName}.vue`
  const viewPath = `../../customers/${customer}/views/${viewName}.vue`
  const viewModule = allCustomerViews[viewPath] ?? allCustomerViews[defaultViewPath]

  return viewModule ? viewModule.default : null
}

export function useCustomerComponent (componentName) {
  const { customer, environmentLevel } = useCustomerManager()
  const AsyncComponent = shallowRef(null)

  const loadComponent = () => {
    const component = getCustomerComponent(customer.value, componentName, environmentLevel.value)
    if (component) {
      AsyncComponent.value = defineAsyncComponent(() =>
        Promise.resolve(component),
      )
    } else {
      console.error(`Component not found: ${componentName} for customer ${customer.value}`)
      AsyncComponent.value = null
    }
  }

  loadComponent()
  watch(() => customer.value, loadComponent)

  return AsyncComponent
}

export function useCustomerView (viewName) {
  const { customer } = useCustomerManager()
  const AsyncComponent = shallowRef(null)

  const loadView = () => {
    const view = getCustomerView(customer.value, viewName)
    if (view) {
      AsyncComponent.value = defineAsyncComponent(() =>
        Promise.resolve(view),
      )
    } else {
      console.error(`View not found: ${viewName} for customer ${customer.value}`)
      AsyncComponent.value = null
    }
  }

  loadView()
  watch(() => customer.value, loadView)

  return AsyncComponent
}
